import { render, staticRenderFns } from "./zengpin.vue?vue&type=template&id=56882bd8&scoped=true"
import script from "./zengpin.vue?vue&type=script&lang=js"
export * from "./zengpin.vue?vue&type=script&lang=js"
import style0 from "./zengpin.vue?vue&type=style&index=0&id=56882bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56882bd8",
  null
  
)

export default component.exports